import "css/tailwind.css";
import ReactDOM from "react-dom";
import { BrowserRouter, Route, Switch } from "react-router-dom";
import { HomeV2 } from "./visual-components/HomeV2";

/**
 * Dedicated client entry for the public homepage at /home.
 *
 * Kept isolated from home-main.jsx so the bundle doesn't drag in legacy
 * components that import `css/themes/Text.css`, whose unscoped `h1...p {
 * margin: 0; padding: 0 }` and `p { font-family: Larsseit-Light }` rules
 * would otherwise leak onto the new page.
 *
 * @returns {import("react").ReactElement}
 */
function HomeV2App() {
  return (
    <BrowserRouter basename="/home">
      <Switch>
        <Route exact path="/" component={HomeV2} />
      </Switch>
    </BrowserRouter>
  );
}

const anchor = document.getElementById("app-holder");
ReactDOM.render(<HomeV2App />, anchor);
